import { render, staticRenderFns } from "./_SwitchButton.vue?vue&type=template&id=11521c6a&scoped=true&"
import script from "./_SwitchButton.vue?vue&type=script&lang=js&"
export * from "./_SwitchButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11521c6a",
  null
  
)

export default component.exports